import {useEffect, useState} from 'react'
import {QueryStatus, QueryStatusType} from 'src/types'
import {OperacionAFOPU} from "../types/types";
import { HttpAFOPU } from '../api/httoAFOPU';

type UseOperacionResult<TOperacion> = {
    status: QueryStatusType
    operacion: TOperacion | undefined
}

export const useOperacionAFOPU: (idOperacion: number) => UseOperacionResult<OperacionAFOPU> = (idOperacion: number) => {
    const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle)
    const [operacion, setOperacion] = useState<OperacionAFOPU>()

    useEffect(() => {
        setStatus(QueryStatus.Loading)

        HttpAFOPU.get(idOperacion)
            .then(data => {
                setOperacion(data)
                setStatus(QueryStatus.Success)
            })
            .catch(() => setStatus(QueryStatus.Error))
    }, [idOperacion])

    return {status, operacion}
}
